__turbopack_context__.v({
  "backdrop-enter": "Backdrop-module__FmPJvq__backdrop-enter",
  "backdrop-enter-active": "Backdrop-module__FmPJvq__backdrop-enter-active",
  "backdrop-exit": "Backdrop-module__FmPJvq__backdrop-exit",
  "backdrop-exit-active": "Backdrop-module__FmPJvq__backdrop-exit-active",
});
